/**
 * Demo account helper
 * Provides demo account credentials and utilities
 */

export const DEMO_ACCOUNTS = [
  {
    id: 'keenan',
    name: 'Keenan Payne',
    email: 'keenan@axioma.com',
    password: 'Demo123!',
    role: 'SuperAdmin',
    avatar: '/keenan.jpg',
  },
  {
    id: 'jaime',
    name: 'Jaime Hernández',
    email: 'jaime@axioma.com',
    password: 'Demo123!',
    role: 'SuperAdmin',
    avatar: '/jaime.png',
  },
] as const

// Legacy export for backwards compatibility
export const DEMO_CREDENTIALS = {
  email: DEMO_ACCOUNTS[0].email,
  password: DEMO_ACCOUNTS[0].password,
} as const

/**
 * Get demo account info for display
 */
export function getDemoAccountInfo() {
  return {
    email: DEMO_CREDENTIALS.email,
    password: DEMO_CREDENTIALS.password,
    name: DEMO_ACCOUNTS[0].name,
    role: DEMO_ACCOUNTS[0].role,
  }
}
